<div class="rounded-2xl border border-neutral-4 bg-white dark:bg-neutral-2 p-5 shadow-xs flex flex-col gap-4">
  <!-- CAS 1 : Aucun rendez-vous proposé pour l'instant -->
  @if (!appointment()) {
    <div class="flex items-start gap-3">
      <div
        class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
      >
        <mat-icon>calendar_month</mat-icon>
      </div>
      <div class="flex flex-col gap-1">
        <h4 class="text-sm font-bold text-neutral-12 m-0">Visite physique du bien</h4>
        <p class="text-xs text-neutral-10 m-0 leading-relaxed">
          Avant de finaliser son offre et ses honoraires, l'agent doit visiter le bien pour constater son état
          réel.
        </p>
      </div>
    </div>

    @if (isOwner()) {
      <button
        type="button"
        mat-flat-button
        class="primary w-full !py-3 font-bold flex items-center justify-center gap-2 text-sm shadow-xs"
        (click)="onProposeVisit()"
      >
        <span>Proposer 3 créneaux de visite</span>
      </button>
    } @else {
      <div
        class="rounded-lg p-3 bg-neutral-2 border border-neutral-3 text-xs text-neutral-11 flex items-center gap-2"
      >
        <mat-icon class="text-neutral-9 text-base!">info</mat-icon>
        <span>En attente de la proposition de visite par le propriétaire.</span>
      </div>
    }
  }

  <!-- CAS 2 : 3 créneaux proposés (Statut PROPOSED) -->
  @else if (isProposed()) {
    <div class="flex items-start justify-between gap-3">
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 rounded-xl bg-amber-2 text-amber-11 flex items-center justify-center shrink-0">
          <mat-icon class="text-lg!">event_note</mat-icon>
        </div>
        <div>
          <h4 class="text-sm font-bold text-neutral-12 m-0">Créneaux de visite proposés</h4>
          <p class="text-xs text-neutral-10 m-0">
            @if (isOwner()) {
              En attente du choix de l'agent immobilier
            } @else {
              Sélectionnez le créneau qui vous convient
            }
          </p>
        </div>
      </div>
      <span
        class="px-2.5 py-1 text-xs font-semibold rounded-full bg-amber-2 text-amber-11 border border-amber-4"
      >
        3 options
      </span>
    </div>

    @if (deadline(); as target) {
      <aura-countdown
        [targetDate]="target"
        variant="banner"
        [showProgress]="true"
        [prefix]="isOwner() ? 'Délai accordé à l\'agent :' : 'Temps restant pour confirmer :'"
      ></aura-countdown>
    }

    <!-- Liste des 3 créneaux -->
    <div class="flex flex-col gap-2">
      @for (slot of proposedSlots(); track slot._id || $index; let i = $index) {
        @let isSelected = !!slot._id && selectedSlotId() === slot._id;
        <button
          type="button"
          (click)="slot._id && selectSlot(slot._id)"
          [disabled]="isOwner()"
          [class]="
            'w-full text-left rounded-xl p-3.5 border transition-all ' +
            (!isOwner() ? 'cursor-pointer ' : 'cursor-default ') +
            (isSelected
              ? 'bg-primary-9 border-primary-9 text-white shadow-sm'
              : 'bg-neutral-1 border-neutral-3 hover:border-neutral-5 text-neutral-12')
          "
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <span
                [class]="
                  'w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ' +
                  (isSelected ? 'bg-white/20 text-white' : 'bg-neutral-3 text-neutral-11')
                "
              >
                {{ i + 1 }}
              </span>
              <div>
                <p [class]="'text-xs font-bold m-0 ' + (isSelected ? 'text-white' : 'text-neutral-12')">
                  {{ slot.startAt | date: "EEEE d MMMM y 'à' HH'h'mm" : '' : 'fr-FR' }}
                </p>
                <p [class]="'text-[11px] m-0 ' + (isSelected ? 'text-white/80' : 'text-neutral-10')">
                  Durée convenue : 45 min
                </p>
              </div>
            </div>

            @if (!isOwner()) {
              <div
                [class]="
                  'w-5 h-5 rounded-full border flex items-center justify-center shrink-0 ' +
                  (isSelected ? 'border-white bg-white text-primary-9' : 'border-neutral-6 bg-transparent')
                "
              >
                @if (isSelected) {
                  <mat-icon class="text-xs! w-3.5! h-3.5! font-bold">check</mat-icon>
                }
              </div>
            }
          </div>
        </button>
      }
    </div>

    <!-- Actions Agent -->
    @if (!isOwner()) {
      <div class="flex flex-col gap-2 pt-1">
        @if (!showRescheduleForm()) {
          <button
            type="button"
            mat-flat-button
            class="primary w-full !py-3 font-bold flex items-center justify-center gap-2 text-sm"
            [disabled]="!selectedSlotId()"
            (click)="onConfirmSlot()"
          >
            <mat-icon class="text-base!">done_all</mat-icon>
            <span>Confirmer ce créneau de visite</span>
          </button>

          <button
            type="button"
            (click)="toggleRescheduleForm()"
            class="w-full py-2 px-3 text-xs font-semibold text-neutral-11 hover:text-neutral-12 hover:bg-neutral-2 rounded-xl transition-all text-center flex items-center justify-center gap-1.5 cursor-pointer"
          >
            <mat-icon class="text-base!">event_repeat</mat-icon>
            <span>Aucun créneau ne vous convient ?</span>
          </button>
        } @else {
          <div class="p-3.5 rounded-xl bg-neutral-2 border border-neutral-4 flex flex-col gap-2.5 mt-1">
            <div class="flex items-center justify-between">
              <span class="text-xs font-bold text-neutral-12">Demander d'autres créneaux</span>
              <button
                type="button"
                (click)="toggleRescheduleForm()"
                class="text-neutral-9 hover:text-neutral-12 p-0.5 cursor-pointer"
              >
                <mat-icon class="text-sm!">close</mat-icon>
              </button>
            </div>
            <p class="text-[11px] text-neutral-10 m-0">
              Indiquez vos disponibilités pour aider le propriétaire à vous proposer de meilleures dates.
            </p>
            <textarea
              [ngModel]="rescheduleReason()"
              (ngModelChange)="rescheduleReason.set($event)"
              rows="2"
              placeholder="Ex : Plutôt disponible les mardis et jeudis après-midi..."
              aria-label="Disponibilités pour report"
              class="w-full text-xs p-2.5 rounded-lg border border-neutral-4 bg-white dark:bg-neutral-1 text-neutral-12 focus:outline-none focus:border-primary-8 resize-none"
            ></textarea>
            <div class="flex items-center gap-2 justify-end">
              <button
                type="button"
                (click)="toggleRescheduleForm()"
                class="px-3 py-1.5 rounded-lg text-xs font-semibold text-neutral-11 hover:bg-neutral-3 cursor-pointer"
              >
                Annuler
              </button>
              <button
                type="button"
                mat-flat-button
                class="primary !py-1.5 !px-3 font-semibold text-xs"
                (click)="onRequestReschedule()"
              >
                <span>Envoyer la demande</span>
              </button>
            </div>
          </div>
        }
      </div>
    }
  }

  <!-- CAS 3 : Nouveaux créneaux demandés par l'agent (Statut RESCHEDULED) -->
  @else if (isRescheduled()) {
    <div class="flex items-start justify-between gap-3">
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 rounded-xl bg-amber-2 text-amber-11 flex items-center justify-center shrink-0">
          <mat-icon class="text-lg!">event_repeat</mat-icon>
        </div>
        <div>
          <h4 class="text-sm font-bold text-neutral-12 m-0">Nouveaux créneaux demandés</h4>
          <p class="text-xs text-neutral-10 m-0">
            @if (isOwner()) {
              L'agent souhaite d'autres disponibilités
            } @else {
              Demande transmise au propriétaire
            }
          </p>
        </div>
      </div>
      <span
        class="px-2.5 py-1 text-xs font-semibold rounded-full bg-amber-2 text-amber-11 border border-amber-4"
      >
        À renouveler
      </span>
    </div>

    @if (deadline(); as target) {
      <aura-countdown
        [targetDate]="target"
        variant="banner"
        [prefix]="
          isOwner() ? 'Temps restant pour proposer de nouveaux créneaux :' : 'Délai accordé au propriétaire :'
        "
      ></aura-countdown>
    }

    @if (appointment()?.cancellationReason) {
      <div class="rounded-xl p-3 bg-amber-1 border border-amber-3 text-xs flex flex-col gap-1">
        <span class="font-semibold text-[11px] text-amber-11">Précision de l'agent :</span>
        <p class="m-0 italic text-neutral-12">« {{ appointment()?.cancellationReason }} »</p>
      </div>
    }

    @if (isOwner()) {
      <div class="pt-1">
        <button
          type="button"
          mat-flat-button
          class="primary w-full !py-3 font-bold flex items-center justify-center gap-2 text-sm shadow-xs"
          (click)="onProposeVisit()"
        >
          <mat-icon class="text-base!">add_alarm</mat-icon>
          <span>Proposer 3 nouveaux créneaux</span>
        </button>
      </div>
    } @else {
      <div
        class="rounded-lg p-3 bg-neutral-2 border border-neutral-3 text-xs text-neutral-11 flex items-center gap-2"
      >
        <mat-icon class="text-neutral-9 text-base!">schedule</mat-icon>
        <span>En attente des nouvelles propositions du propriétaire.</span>
      </div>
    }
  }

  <!-- CAS 4 : Rendez-vous confirmé (Statut CONFIRMED) -->
  @else if (isConfirmed()) {
    <div class="flex items-start justify-between gap-3">
      <div class="flex items-center gap-2.5">
        <div
          class="w-9 h-9 rounded-xl bg-emerald-2 text-emerald-11 flex items-center justify-center shrink-0"
        >
          <mat-icon class="text-lg!">event_available</mat-icon>
        </div>
        <div>
          <h4 class="text-sm font-bold text-neutral-12 m-0">Rendez-vous confirmé</h4>
          <p class="text-xs text-neutral-10 m-0">Visite physique planifiée</p>
        </div>
      </div>
      <span
        class="px-2.5 py-1 text-xs font-semibold rounded-full bg-emerald-2 text-emerald-11 border border-emerald-4"
      >
        Validé
      </span>
    </div>

    <!-- Détail du créneau retenu -->
    @if (confirmedSlot()) {
      <div class="rounded-xl p-4 bg-emerald-1 border border-emerald-3 flex flex-col gap-2">
        <div class="flex items-center gap-2 text-emerald-12 font-bold text-sm">
          <mat-icon class="text-emerald-11 text-base!">schedule</mat-icon>
          <span>{{ confirmedSlot()?.startAt | date: "EEEE d MMMM y 'à' HH'h'mm" : '' : 'fr-FR' }}</span>
        </div>
        @if (property()?.location?.address?.city) {
          @if (isAddressRevealed()) {
            <div class="flex items-center gap-2 text-xs text-neutral-11">
              <mat-icon class="text-neutral-9 text-base!">place</mat-icon>
              <span>
                {{
                  property()?.location?.address?.label ||
                    (property()?.location?.address?.street
                      ? property()?.location?.address?.street + ', '
                      : '') + (property()?.location?.address?.city || '')
                }}
              </span>
            </div>
          } @else {
            <div class="flex items-center gap-2 text-xs text-neutral-11">
              <mat-icon class="text-neutral-9 text-base!">place</mat-icon>
              <span>
                {{ property()?.location?.address?.city }}
                @if (property()?.location?.address?.zipCode) {
                  ({{ property()?.location?.address?.zipCode }})
                }
              </span>
            </div>
            <div
              class="flex items-start gap-2 p-2.5 rounded-lg bg-amber-1/80 border border-amber-3 text-amber-11 text-xs"
            >
              <mat-icon class="text-amber-9 text-base! shrink-0 mt-0.5">lock</mat-icon>
              <span>
                @if (isOwner()) {
                  L'adresse exacte de votre bien sera automatiquement dévoilée à l'agent 24 h avant le
                  rendez-vous.
                } @else {
                  L'adresse exacte du bien vous sera dévoilée 24 h avant le rendez-vous.
                }
              </span>
            </div>
          }
        }
      </div>
    }

    <!-- Boutons d'action après la date du rendez-vous -->
    @if (isVisitPassed()) {
      <div class="pt-1 flex flex-col gap-2">
        @if (!isOwner()) {
          <button
            type="button"
            mat-flat-button
            class="primary w-full !py-3 font-bold flex items-center justify-center gap-2 text-xs"
            (click)="onMarkAsVisited()"
          >
            <mat-icon class="text-base!">check_circle</mat-icon>
            <span>Confirmer la visite effectuée</span>
          </button>
        }

        @if (isOwner()) {
          @if (!showNoShowForm()) {
            <button
              type="button"
              mat-stroked-button
              class="w-full !py-2.5 font-semibold flex items-center justify-center gap-1.5 text-xs !text-red-11 !border-red-6 hover:!bg-red-2 transition-all cursor-pointer"
              (click)="toggleNoShowForm()"
            >
              <mat-icon class="text-base!">person_off</mat-icon>
              <span>Signaler l’absence de l’agent (No-show)</span>
            </button>
          } @else {
            <div class="p-3.5 rounded-xl bg-red-1/60 border border-red-4 flex flex-col gap-2.5">
              <div class="flex items-center justify-between">
                <span class="text-xs font-bold text-red-12">Signaler l’absence de l’agent</span>
                <button
                  type="button"
                  (click)="toggleNoShowForm()"
                  class="text-neutral-9 hover:text-neutral-12 p-0.5 cursor-pointer"
                >
                  <mat-icon class="text-sm!">close</mat-icon>
                </button>
              </div>
              <p class="text-[11px] text-neutral-11 m-0">
                Si l’agent ne s’est pas présenté au rendez-vous, cette action clôturera définitivement sa
                candidature.
              </p>
              <textarea
                [ngModel]="noShowReason()"
                (ngModelChange)="noShowReason.set($event)"
                rows="2"
                placeholder="Précisez un motif facultatif (ex : absent sans prévenir)..."
                aria-label="Motif du signalement d'absence"
                class="w-full text-xs p-2.5 rounded-lg border border-red-4 bg-white dark:bg-neutral-1 text-neutral-12 focus:outline-none focus:border-red-7 resize-none"
              ></textarea>
              <div class="flex items-center gap-2 justify-end">
                <button
                  type="button"
                  (click)="toggleNoShowForm()"
                  class="px-3 py-1.5 rounded-lg text-xs font-semibold text-neutral-11 hover:bg-neutral-3 cursor-pointer"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  mat-flat-button
                  class="!bg-red-9 !text-white !py-1.5 !px-3 font-semibold text-xs"
                  (click)="onReportNoShow()"
                >
                  <span>Confirmer le signalement</span>
                </button>
              </div>
            </div>
          }
        }
      </div>
    }
  }

  <!-- CAS 4 : Visite effectuée (Statut COMPLETED) -->
  @else if (isCompleted()) {
    <div class="flex items-center gap-2.5">
      <div class="w-9 h-9 rounded-xl bg-jade-2 text-jade-11 flex items-center justify-center shrink-0">
        <mat-icon class="text-lg!">verified</mat-icon>
      </div>
      <div>
        <h4 class="text-sm font-bold text-neutral-12 m-0">Visite physique réalisée</h4>
        <p class="text-xs text-neutral-10 m-0">Étape suivante : avis de valeur et offre finale de l’agent</p>
      </div>
    </div>

    <div
      class="rounded-xl p-3 bg-neutral-2 border border-neutral-3 text-xs text-neutral-11 flex flex-col gap-2"
    >
      <span>
        Le bien a été visité sur place. L’agent dispose d’un délai de 72h pour remettre son avis de valeur et
        son offre définitive.
      </span>

      @if (isOwner()) {
        @if (!showNoShowForm()) {
          <div class="pt-1">
            <button
              type="button"
              (click)="toggleNoShowForm()"
              class="text-[11px] text-red-11 hover:underline flex items-center gap-1 cursor-pointer"
            >
              <mat-icon class="text-xs! size-3.5">report_problem</mat-icon>
              <span>L’agent ne s’est pas présenté ? Signaler une absence</span>
            </button>
          </div>
        } @else {
          <div class="p-3 rounded-lg bg-red-1/60 border border-red-4 flex flex-col gap-2 mt-1">
            <span class="text-xs font-bold text-red-12">Recours no-show sous 24h</span>
            <p class="text-[11px] text-neutral-11 m-0">
              Vous contestez la tenue de cette visite ? Cette action annulera la candidature.
            </p>
            <textarea
              [ngModel]="noShowReason()"
              (ngModelChange)="noShowReason.set($event)"
              rows="2"
              placeholder="Précisez pourquoi la visite n’a pas eu lieu..."
              aria-label="Motif de contestation de la visite"
              class="w-full text-xs p-2 rounded border border-red-4 bg-white dark:bg-neutral-1 text-neutral-12 focus:outline-none focus:border-red-7 resize-none"
            ></textarea>
            <div class="flex items-center gap-2 justify-end">
              <button
                type="button"
                (click)="toggleNoShowForm()"
                class="px-2.5 py-1 text-xs font-semibold text-neutral-11 hover:bg-neutral-3 cursor-pointer"
              >
                Annuler
              </button>
              <button
                type="button"
                mat-flat-button
                class="!bg-red-9 !text-white !py-1 !px-2.5 font-semibold text-xs"
                (click)="onReportNoShow()"
              >
                <span>Confirmer l’absence</span>
              </button>
            </div>
          </div>
        }
      }
    </div>
  }

  <!-- CAS 5 : Rendez-vous non honoré (Statut NO_SHOW) -->
  @else if (isNoShow()) {
    <div class="flex items-center gap-2.5">
      <div class="w-9 h-9 rounded-xl bg-red-2 text-red-11 flex items-center justify-center shrink-0">
        <mat-icon class="text-lg!">person_off</mat-icon>
      </div>
      <div>
        <h4 class="text-sm font-bold text-neutral-12 m-0">Rendez-vous non honoré</h4>
        <p class="text-xs text-neutral-10 m-0">L’absence de l’agent a été constatée</p>
      </div>
    </div>

    <div class="rounded-xl p-3 bg-red-1/60 border border-red-4 text-xs text-neutral-12">
      L’agent ne s’étant pas présenté au rendez-vous convenu, cette démarche a été clôturée et sa candidature
      écartée.
    </div>
  }

  <!-- Historique des créneaux précédemment déclinés -->
  @if (declinedSlots().length > 0 && !isCompleted()) {
    <div class="pt-2 border-t border-neutral-3 flex flex-col gap-2">
      <button
        type="button"
        (click)="toggleHistory()"
        class="w-full flex items-center justify-between text-[11px] font-semibold text-neutral-10 hover:text-neutral-12 transition-colors cursor-pointer py-1"
      >
        <div class="flex items-center gap-1.5">
          <mat-icon class="text-xs! w-3.5! h-3.5!">history</mat-icon>
          <span>Créneaux précédents refusés ({{ declinedSlots().length }})</span>
        </div>
        <mat-icon class="text-xs! w-3.5! h-3.5! transition-transform" [class.rotate-180]="showHistory()">
          expand_more
        </mat-icon>
      </button>

      @if (showHistory()) {
        <div class="flex flex-col gap-1.5 pl-2 border-l-2 border-neutral-4">
          @for (slot of declinedSlots(); track slot._id || $index) {
            <div class="flex flex-col gap-0.5 py-1 text-[11px] text-neutral-10">
              <div class="flex items-center justify-between">
                <span class="line-through">
                  {{ slot.startAt | date: "EEEE d MMMM y 'à' HH'h'mm" : '' : 'fr-FR' }}
                </span>
                <span class="px-1.5 py-0.5 text-[10px] rounded bg-neutral-3 text-neutral-11"> Refusé </span>
              </div>
              @if (slot.declineReason) {
                <span class="text-[10px] italic text-neutral-9"> Motif : « {{ slot.declineReason }} » </span>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
